import React from 'react';

interface GameExpiredScreenProps {
  onCreateNew: () => void;
}

const GameExpiredScreen: React.FC<GameExpiredScreenProps> = ({ onCreateNew }) => {
  return (
    <div style={{ 
      position: 'absolute', 
      top: '50%', 
      left: '50%', 
      transform: 'translate(-50%, -50%)', 
      textAlign: 'center', 
      zIndex: 10, 
      color: '#FFC107', 
      touchAction: 'none' 
    }}>
      <h2 style={{ fontSize: '2rem', marginBottom: 20 }}>
        This game has already expired.
      </h2>
      <button 
        style={{
          // margin: '5px',
          padding: '15px 40px',
          fontSize: '1.5rem',
          backgroundColor: '#FFC107',
          border: 'none',
          borderRadius: '30px',
          cursor: 'pointer',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          transition: 'transform 0.2s, box-shadow 0.2s',
          WebkitTapHighlightColor: 'transparent',
          touchAction: 'manipulation',
          minWidth: '200px',
          minHeight: '60px',
          margin: '10px'
        }} 
        onClick={onCreateNew}
      >
        Create New
      </button>
    </div>
  );
};

export default GameExpiredScreen; 